import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'disableMenuSearch',
  initialState: false,
  reducers: {
    setDisableMenuSearch(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDisableMenuSearch } = slice.actions;

export default slice.reducer;
